"use client";

import {Text, HStack, StackProps, Input, InputProps, ButtonProps, Stack, Icon} from "@chakra-ui/react";
import {CheckIcon} from "@heroicons/react/20/solid";
import Button from "../components/Button";
import useSubscribe from "../app/utils/useSubscribe";

type SubscribeProps = {
  size?: "sm";
  inputProps?: InputProps;
  buttonProps?: ButtonProps;
  dark?: boolean;
} & StackProps;

const Subscribe = ({size, dark, buttonProps, inputProps, ...props}: SubscribeProps) => {
  const {email, setEmail, error, isLoading, onSubmit, success} = useSubscribe();

  return (
    <Stack {...props}>
      <HStack as="form" onSubmit={onSubmit}>
        <Input
          placeholder="Enter your email"
          color={dark ? "white" : undefined}
          bg={dark ? "gray.700" : "white"}
          borderColor={dark ? "gray.700" : undefined}
          value={email ?? ""}
          disabled={isLoading || success}
          _placeholder={dark ? {opacity: 1, color: "gray.400"} : undefined}
          onChange={e => setEmail(e.target.value)}
          size={size}
          flex={1}
          _hover={{borderColor: dark ? "gray.600" : "gray.400"}}
          {...inputProps}
        />
        <Button
          size={size}
          type="submit"
          colorPalette="green"
          disabled={success || error !== undefined}
          loading={isLoading}
          {...buttonProps}
        >
          {success ? (
            <Icon size="md">
              <CheckIcon />
            </Icon>
          ) : (
            "Subscribe"
          )}
        </Button>
      </HStack>
      {error && (
        <Text fontSize="sm" color="red.500">
          {error}
        </Text>
      )}
      {success && (
        <Text fontSize="sm" color="green.400">
          Thanks for subscribing!
        </Text>
      )}
    </Stack>
  );
};

export default Subscribe;
